"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTeam = exports.memberDisplayName = exports.getTitle = exports.getTitleOrUntitledRecordString = exports.isRecordDeleted = exports.isRecordNotDeleted = void 0;
const types_1 = require("@smartsuite/types");
const texts_1 = require("../texts");
const intl_1 = require("../locale/intl");
const member_1 = require("./member");
const status_1 = require("./status");
function isRecordNotDeleted(record) {
    var _a;
    return !((_a = record === null || record === void 0 ? void 0 : record.deleted_date) === null || _a === void 0 ? void 0 : _a.date);
}
exports.isRecordNotDeleted = isRecordNotDeleted;
function isRecordDeleted(record) {
    var _a;
    return !!((_a = record === null || record === void 0 ? void 0 : record.deleted_date) === null || _a === void 0 ? void 0 : _a.date);
}
exports.isRecordDeleted = isRecordDeleted;
/**
 * Returns record title from a record instance or `Untitled Record` string if title is empty.
 */
function getTitleOrUntitledRecordString(record) {
    const title = getTitle(record);
    if (title) {
        return title;
    }
    return (0, intl_1.$t)(texts_1.recordText.untitled_record);
}
exports.getTitleOrUntitledRecordString = getTitleOrUntitledRecordString;
/**
 * Returns record title from a record instance.
 */
function getTitle(record) {
    var _a, _b;
    if (!record) {
        return "";
    }
    if ((0, member_1.isMember)(record)) {
        return memberDisplayName(record);
    }
    if (isTeam(record)) {
        return record.name;
    }
    return (_b = (_a = record.title) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : "";
}
exports.getTitle = getTitle;
function memberDisplayName(member) {
    var _a, _b, _c;
    if (!member)
        return "";
    const status = (0, status_1.getMemberOrTeamStatus)(member).value;
    if (status === types_1.MemberStatuses.invited) {
        return (_b = (_a = member.email) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : "";
    }
    const { first_name = "", last_name = "" } = (_c = member.full_name) !== null && _c !== void 0 ? _c : {};
    return `${first_name} ${last_name}`.trim();
}
exports.memberDisplayName = memberDisplayName;
function isTeam(record) {
    return record.application_slug === types_1.TEAMS_APP_SLUG;
}
exports.isTeam = isTeam;
